import {AfterViewInit, Component, ComponentFactoryResolver, Inject, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ModalRegraCompostaComponent} from "../modal-regra-composta/modal-regra-composta.component";
import {CadastroRegraComponent} from "../../../regra/cadastro-regra/cadastro-regra.component";

@Component({
    selector: 'app-modal-regra',
    templateUrl: './modal-regra.component.html',
    styleUrls: ['./modal-regra.component.scss']
})
export class ModalRegraComponent implements OnInit, AfterViewInit {

    @ViewChild("view", {static: true, read: ViewContainerRef})
    private readonly detailsView: ViewContainerRef;
    private component;

    constructor(@Inject(MAT_DIALOG_DATA) readonly data,
                private readonly cfr: ComponentFactoryResolver) {
    }

    ngOnInit(): void {
        if (this.data.entityModel.regrasAssociadas && this.data.entityModel.regrasAssociadas !== '' && this.data.entityModel.regrasAssociadas.length !== 0) {
            this.component = this.detailsView.createComponent(
                this.cfr.resolveComponentFactory(ModalRegraCompostaComponent)).instance;
        } else {
            this.component = this.detailsView.createComponent(
                this.cfr.resolveComponentFactory(CadastroRegraComponent)).instance;
        }
    }

    ngAfterViewInit(){
        if(this.component instanceof CadastroRegraComponent){
            this.component.isConsulta = true;
            this.component.ngOnInit()
            this.component.isDiolog = true;
            this.component.popularRegra(this.data.entityModel);
        }else{
            this.component.data = this.data.entityModel;
            this.component.ngOnInit();
        }
    }


}
